<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <h1 class="mt-0">Assegnazione massiva delle credenziali</h1>

        <span>Utilizza questa funzione per assegnare le credenziali a più utenti contemporaneamente</span>

        <v-select v-model="selection_type"
          :options="selection_types"
          :reduce="val => val.value"
          :clearable="false"
          :filterable="false"
          :searchable="false"
          placeholder="Indica il tipo di selezione degli utenti"/>


        <!-- Selezione manuale -->
        <section class="users" v-if="selection_type == 'manual'">

          <h3 class="uc mt-0">Tipi di utenti</h3>

          <v-checkbox :label="'Clienti'" v-model="type.customers"></v-checkbox>
          <v-checkbox :label="'Utenti registrati'" v-model="type.registered" ></v-checkbox>

        </section>


        <!-- Selezione da file -->
        <section class="users" v-if="selection_type == 'file'">

          <h3 class="uc mt-0">Tipi di utenti</h3>

          <v-checkbox :label="'Clienti'" v-model="type.customers"></v-checkbox>
          <v-checkbox :label="'Utenti registrati'" v-model="type.registered" ></v-checkbox>

        </section>

        <button class="belt-btn animated" :class="{loading: loading}" @click="massAssign()">Assegna credenziali</button>

      </div>

    </transition>

  </div>

</template>

<script>
export default{

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data
      checkbox_label: 'Assegna l\'indirizzo email automaticamente in base all\'indirizzo di riferimento',
      auto_email_assign: true,
      selection_types: [
        {
          label: 'Selezione manuale',
          value: 'manual'
        },
        {
          label: 'Upload file',
          value: 'file'
        },
      ],
      selection_type: null,
      type: {
        customers: false,
        registered: false
      }

    }

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 200, this);

    },

    massAssign: function(){

      var vue = this;

      // axios({
      //   method: "",
      //   url: ,
      //   data: {

      //   }
      // })
      // .then(res => {

      // })
      // .catch(err => {

      // })
      // .then(() =>{

      // })

    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.massAssignment = false;

  }

}
</script>

<style scoped>
.modal-custom{
  background-color: white;
  max-width: 800px;
  padding: 30px 20px;
  height: 100vh;
}
</style>
